import styled from "styled-components";

export default styled.div`
  .materialUi__dropdown {
    .materialUi__dropdown--toggle {
      svg {
        transition: transform 0.6s ease 0s;
      }
    }
    .materialUi__dropdown--toggle--active {
      color: #1EBEC8 !important;
      svg {
        transform: rotate(-180deg);
        transition: transform 0.6s ease 0s;
      }
    }
    .materialUi__dropdown--menu {
      margin-top: 21px;
    }
  }

  .categories-container {
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr 1fr 1fr 1fr 1fr;
    grid-auto-columns: 1fr;
    grid-auto-flow: column;
    padding: 0 10px;
    a {
      font-size: 12px !important;
      button {
        text-transform: none;
        min-width: 130px;
        font-size: 12px !important;
        transition: all 0.6s ease 0s;
        color: rgba(0, 0, 0, 0.87) !important;
        &:hover {
          color: #1EBEC8 !important;
          background: #f7f4f4 !important;
        }
        span {
          &.MuiButton-label {
            justify-content: start;
          }
        }
      }
    }
  }
`;
